export default {
	name: 'Users',
	options: {
		schema: 'users',
		table: 'v_active_users'
	}
};

